import AddUserModalSelectRole from './component'

export default AddUserModalSelectRole
